import { Button, Stack } from "@mui/material"
import { getFlagReviewButtonSx } from "routes/schedule/plugins/legislation-resolutions/review-decision-button-presenters"

export function ReviewProjectResolutionBulkActions({ changes, onDecideAll }) {
    if (!changes?.length) return null

    return (
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            <Button size="small" variant="outlined" color="success" onClick={acceptAll}>
                Accept All
            </Button>
            <Button size="small" variant="outlined" onClick={keepAll}>
                Keep Current
            </Button>
            <Button
                size="small"
                variant="outlined"
                color="inherit"
                onClick={flagAll}
                sx={getFlagReviewButtonSx({ emphasizeInactive: true })}
            >
                Flag All for Review
            </Button>
        </Stack>
    )

    function acceptAll() {
        onDecideAll?.("accept")
    }

    function keepAll() {
        onDecideAll?.("keep")
    }

    function flagAll() {
        onDecideAll?.("custom")
    }
}
